module.exports = __webpack_public_path__ + "img/qa.afe5a1c2.svg";